import { render, staticRenderFns } from "./projectApply.vue?vue&type=template&id=16b950d9&scoped=true"
import script from "./projectApply.vue?vue&type=script&lang=js"
export * from "./projectApply.vue?vue&type=script&lang=js"
import style0 from "./projectApply.vue?vue&type=style&index=0&id=16b950d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b950d9",
  null
  
)

export default component.exports